import React from 'react';
import IconYesPhotoAC from './icon-yes-photo.svg';
import IconYesIllustAC from './icon-yes-ill.svg';
import IconYesSilhouetteAC from './icon-yes-sil.svg';
import IconNo from './icon-no.svg';
import IconStar from './icon-star.svg';
import withI18next from '~/../hocs/_withI18next';
import { SERVICE_TYPES } from '~/utils/constants';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';

const COMPARE_LIST = [
  {
    textKey: 'criteria_1',
    free: true,
    premium: true,
  },
  {
    textKey: 'criteria_2',
    free: true,
    premium: true,
  },
  {
    textKey: 'criteria_3',
    free: false,
    premium: true,
  },
  {
    textKey: 'criteria_4',
    free: false,
    premium: true,
  },
  {
    textKey: 'criteria_5',
    free: false,
    premium: true,
  },
  {
    textKey: 'criteria_6',
    free: false,
    premium: true,
  },
  {
    textKey: 'criteria_7',
    free: false,
    premium: true,
  },
  {
    textKey: 'criteria_8',
    free: false,
    premium: true,
  },
];

const ICON_YES = {
  [SERVICE_TYPES.PHOTO_AC]: IconYesPhotoAC,
  [SERVICE_TYPES.ILLUST_AC]: IconYesIllustAC,
  [SERVICE_TYPES.SILHOUETTE_AC]: IconYesSilhouetteAC,
  [SERVICE_TYPES.DESIGN_AC]: IconYesPhotoAC,
};
const IconYes = IconYesIllustAC;

const FreeAndPremiumCompareTable = ({ t, style }) => (
  <div className="free-and-premium-compare-table">
    <table style={style}>
      <thead>
        <tr className="header-row">
          <th className="header-cell criteria-cell">{t('header_features')}</th>
          <th className="header-cell icon-cell">{t('header_free_users')}</th>
          <th className="header-cell icon-cell header-premium">
            <span className="header-premium-icon">
              <IconStar />
            </span>
            {t('header_premium_users')}
          </th>
        </tr>
      </thead>
      <tbody>
        {COMPARE_LIST.map((item, idx) => (
          <tr key={item.textKey} className="item-row">
            <td className="criteria-cell">{t(item.textKey)}</td>
            <td className="icon-cell">
              {item.free ? <IconYes /> : <IconNo />}
            </td>
            <td className="icon-cell header-premium">
              {item.premium ? <IconYes /> : <IconNo />}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    <style jsx>
      {`
        .free-and-premium-compare-table {
          width: 100%;
          background: #ffffff;
          border: 1px solid #e3e3e3;
          box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.08);
          border-radius: 8px;
          padding: 32px;
        }

        .free-and-premium-compare-table table {
          width: 100%;
        }

        .header-row,
        .item-row {
          width: 100%;
          min-height: 40px;
          display: flex;
          flex-direction: row;
          align-items: center;
          color: #000000;
        }
        .item-row {
          font-weight: 500;
          line-height: 28px;
        }

        .header-cell {
          font-weight: 600;
          font-size: 20px;
        }

        .criteria-cell,
        .icon-cell {
          white-space: break-spaces;
        }

        .header-premium {
          display: flex;
        }

        .criteria-cell {
          text-align: left;
          width: 50%;
        }

        .icon-cell {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 20%;
          text-align: center;
        }

        .header-premium {
          width: 30%;
        }

        @media (max-width: 768px) {
          .free-and-premium-compare-table {
            width: 100%;
          }

          .criteria-cell {
            width: 60%;
          }

          .icon-cell {
            width: 20%;
          }

          .header-premium {
            width: 30%;
          }
        }

        @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
          .free-and-premium-compare-table {
            padding: 16px 10px;
            margin-top: 24px;
          }

          .header-cell {
            font-size: 16px !important;
          }

          .header-premium-icon {
            display: none;
          }

          .item-row {
            font-size: 14px;
          }
        }
      `}
    </style>
  </div>
);

export default withI18next(['component-FreeAndPremiumCompareTable'])(
  FreeAndPremiumCompareTable,
);
